export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="border-t border-[#1e293b]/70 py-12 font-mono text-xs text-[#64748b]"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-6 md:flex-row">
        <div className="flex items-center gap-2">
          <span className="font-bold text-white">runloft</span>
          <span>© 2026. Cloud computers for coding agents.</span>
        </div>
        <div className="flex items-center gap-6">
          <a href="#hero" data-testid="footer-top-link" className="transition-colors hover:text-white">
            Top
          </a>
          <a href="#features" data-testid="footer-specs-link" className="transition-colors hover:text-white">
            Specs
          </a>
          <a href="#pricing" data-testid="footer-pricing-link" className="transition-colors hover:text-white">
            Pricing
          </a>
        </div>
      </div>
    </footer>
  );
};
